const shoppingReportReasonURL =
    process.env.REACT_APP_API_HOST +
  `/api/v3/contents/shoppings/paths/joints/reports`

export const createShoppingReport = async (
  shoppingPathJointId: string,
  userId: string,
  shoppingPathJointReportReasonId: number,
) => {
  // console.log(
  //   JSON.stringify({
  //     shoppingPathJointId: shoppingPathJointId,
  //     userId: userId,
  //     shoppingPathJointReportReasonId: shoppingPathJointReportReasonId,
  //   }),
  // )

  const response = await fetch(shoppingReportReasonURL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      shoppingPathJointId: shoppingPathJointId,
      userId: userId,
      shoppingPathJointReportReasonId: shoppingPathJointReportReasonId,
    }),
  })

  if (!response.ok) {
    throw new Error('네트워크 오류: 신고하기 등록에 실패했습니다.')
  }

  const responseData = await response.json()

  console.log(response)

  return responseData
}
